import { categories, vocabulary, countByCategory } from '../data/vocabulary.js';

export function VocabIndex(root) {
  root.innerHTML = `
    <header class="mb-10">
      <a href="/dashboard" data-link
         class="text-sm text-slate2-500 hover:text-moss-700">← Dashboard</a>
      <h1 class="font-display text-4xl font-semibold text-slate2-900
                 mt-2 tracking-tight">Vocabulary</h1>
      <p class="mt-2 text-slate2-500">
        ${vocabulary.length} essential words across ${categories.length} modules.
        Tap any module to drill into it.
      </p>
    </header>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      ${categories.map(c => `
        <a href="/vocab/${c.id}" data-link
           class="card card-interactive flex items-center gap-5">
          <div class="text-4xl shrink-0">${c.icon}</div>
          <div class="min-w-0">
            <div class="flex items-center gap-2 mb-0.5">
              <div class="font-display text-xl font-semibold text-slate2-900">${c.title}</div>
              <span class="badge bg-sand-100 text-slate2-500">${countByCategory(c.id)}</span>
            </div>
            <div class="text-xs text-moss-700 font-medium">${c.norwegian}</div>
            <p class="text-sm text-slate2-500 mt-1.5">${c.description}</p>
          </div>
        </a>
      `).join('')}
    </div>
  `;
}
